import { useField } from 'vee-validate'

export default {
    props: {
        name: { type: String, required: true },
        modelValue: {},
        value: {},
        id: { type: String },
        placeholder: String,
        autocomplete: { type: String, default: null },
        disabled: { type: Boolean, default: null },
        readOnly: { type: Boolean, default: null },
        ignoreValidation: { type: Boolean }
    },
    
    emits: ['update:modelValue'],
    
    data() {
        return {
            inputId: this.id || this.name
        }
    },

    computed: {
        model: {
            get() {
                return this.modelValue
            },
            
            set(value) {
                this.$emit('update:modelValue', value)
            }
        }
    },
    
    created() {
        if (!this.ignoreValidation) {
            useField(this.name, value => this.modelValue)
        }
    },

    methods: {
        onBlur(e) {
            this.$emit('blur', e)
        }
    }
}